import { DesignTokens } from "melco-ui";
import {
  SharedserviceMelcoModelsAlphabetListItem,
  EfsMelcoModelsUserAlphabet,
} from "melco-shared-logic";
import { useFontThumbnailURL } from "../../../hooks/libraries/fonts/useFontThumbnailURL";
import { ListThumbnail } from "../../shared/ListThumbnail";

const { spacings } = DesignTokens;

type FontsListThumbnailProps = {
  font: EfsMelcoModelsUserAlphabet | SharedserviceMelcoModelsAlphabetListItem;
};

export const FontsListThumbnail: React.FC<FontsListThumbnailProps> = ({
  font,
}) => {
  const thumbnailSrc = useFontThumbnailURL(
    font,
    spacings.xlarge,
    spacings.xlarge
  );

  return <ListThumbnail thumbnailSrc={thumbnailSrc ?? undefined} />;
};
